import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { product, withPlaybook, withoutPlaybook } from "../data/landing";
export function ClosingSection() {
  return <section className="bg-soft py-16 md:py-24" data-id="element-14" data-mp="12twptsvjqsr3">
      <div className="mx-auto max-w-[1000px] px-5 sm:px-8" data-id="element-15" data-mp="12qhacoxynhp5">
        <div className="mx-auto mb-12 max-w-[760px] text-center" data-id="element-16" data-mp="xszb5q9qwguc">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-teal" data-id="element-17" data-mp="1cqhv8fbha5vg">The next request is coming</p>
          <h2 className="font-display text-[40px] font-extrabold uppercase leading-[0.98] text-navy sm:text-5xl md:text-[56px]" data-id="element-18" data-mp="17sq25hz3kdpo">
            Start from a blank page, <span className="text-teal" data-id="element-19" data-mp="1ll5zq398bjj7">or start from a plan.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-20" data-mp="1hk403lbeh5gp">
          <div className="rounded-xl border border-line bg-white p-7" data-id="element-21" data-mp="1viamo5awfj12">
            <h3 className="font-display text-2xl font-bold uppercase text-muted" data-id="element-22" data-mp="1qj7iso6nniuo">Without the playbook</h3>
            <ul className="mt-5 space-y-4" data-id="element-23" data-mp="22d5fnunq7ymb">
              {withoutPlaybook.map(item => <li key={item} className="flex gap-3 text-[15px] text-muted" data-id="element-24" data-mp="27anj55iz5lmx">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-muted/60" aria-hidden="true" data-id="element-25" data-mp="2cas0syvmcmeq" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-xl border-2 border-teal bg-white p-7 shadow-[0_20px_50px_rgba(15,118,110,0.12)]" data-id="element-26" data-mp="2lb82c2ssxjgy">
            <h3 className="font-display text-2xl font-bold uppercase text-navy" data-id="element-27" data-mp="2q9rp25f7yzad">
              With <span className="text-teal" data-id="element-28" data-mp="2v11fv9ci88nu">{product.name}</span>
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-29" data-mp="2v349s4gs2lxu">
              {withPlaybook.map(item => <li key={item} className="flex gap-3 text-[15px] font-medium text-ink" data-id="element-30" data-mp="3027712qinnv9">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal" data-id="element-31" data-mp="343j05i8lmr87">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-32" data-mp="38ypzyeyqzbru" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-33" data-mp="1io2xacl14o6d">
          <p className="text-[17px] text-ink/80" data-id="element-34" data-mp="1ipxhfooh8c9e">
            10 workshops + 5 bonuses · 40-page facilitator PDF ·{" "}
            <strong className="text-navy" data-id="element-35" data-mp="1dvjjbeifjr11">
              ${product.price} {product.currency}
            </strong>{" "}
            one-time
          </p>
          <CtaButton href="#offer-details" className="mt-7 w-full sm:w-auto" data-id="element-36" data-mp="1no8tm628uyus">
            Get New Manager Essentials
          </CtaButton>
        </div>
      </div>
    </section>;
}